import React, { Component, Fragment } from "react";
import {
    Container,
    Row,
    Col,
    Button
} from "react-bootstrap";

import Logo from "../../assests/images/Primeluxury.png";
import { Link } from "react-router-dom";
import MegaMenuMobile from "../home/MegaMenuMobile";

class NavMenuMobile extends Component {

    constructor() {
        super();

        this.state = {
            SideNavState: "sideNavClose",
            ContentOverState: "ContentOverlayClose"
        };
    }


    /* =====================================================
       MENU BUTTON
    ===================================================== */

    MenuBarClickHandler = () => {
        this.SideNavOpenClose();
    };


    /* =====================================================
       CLOSE MENU
    ===================================================== */

    ContentOverlayClickHandler = () => {

        this.setState({
            SideNavState: "sideNavClose",
            ContentOverState: "ContentOverlayClose"
        });

    };


    /* =====================================================
       OPEN / CLOSE SIDE MENU
    ===================================================== */

    SideNavOpenClose = () => {

        if (this.state.SideNavState === "sideNavOpen") {

            this.setState({
                SideNavState: "sideNavClose",
                ContentOverState: "ContentOverlayClose"
            });

        } else {

            this.setState({
                SideNavState: "sideNavOpen",
                ContentOverState: "ContentOverlayOpen"
            });

        }
    };


    render() {

        return (

            <Fragment>

                <div className="TopSectionDown">


                    {/* ================= MOBILE NAVBAR ================= */}

                    <Container
                        fluid
                        className="mobile-navbar fixed-top shadow-sm bg-white"
                    >

                        <Row className="align-items-center">


                            {/* ================= MENU + LOGO ================= */}

                            <Col
                                xs={8}
                                className="d-flex align-items-center"
                            >

                                <Button
                                    type="button"
                                    onClick={this.MenuBarClickHandler}
                                    className="mobile-menu-button"
                                >

                                    <i className="fa fa-bars"></i>

                                </Button>


                                <Link
                                    to="/"
                                    className="mobile-logo-link"
                                >

                                    <img
                                        className="mobile-nav-logo"
                                        src={Logo}
                                        alt="Prime Luxury Passenger Transport LLC"
                                    />

                                </Link>

                            </Col>


                            {/* ================= RIGHT ICONS ================= */}

                            <Col
                                xs={4}
                                className="d-flex align-items-center justify-content-end mobile-right-menu"
                            >


                                {/* PHONE */}

                                <a
                                    href="tel:+971501011783"
                                    className="mobile-nav-icon"
                                    title="Call Us"
                                >

                                    <i className="fa fa-phone"></i>

                                </a>


                                {/* EMAIL */}

                                <a
                                    href="mailto:booking@dxblimo.com"
                                    className="mobile-nav-icon"
                                    title="Email Us"
                                >

                                    <i className="fa fa-envelope"></i>

                                </a>


                                {/* LOGIN */}

                                <Link
                                    to="/login"
                                    className="mobile-nav-icon mobile-login-icon"
                                    title="Login"
                                >

                                    <i className="fa fa-user"></i>

                                </Link>


                            </Col>

                        </Row>

                    </Container>


                    {/* ================= SIDE NAVIGATION ================= */}

                    <div className={this.state.SideNavState}>

                        <MegaMenuMobile />

                    </div>


                    {/* ================= OVERLAY ================= */}

                    <div
                        onClick={this.ContentOverlayClickHandler}
                        className={this.state.ContentOverState}
                    ></div>


                </div>

            </Fragment>
        );
    }
}

export default NavMenuMobile;